import { useEffect, useState } from 'react'
import theme from '../gatsby-plugin-theme-ui'
import { Window } from '../utils'

export function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  })

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    // Add event listener
    Window.addEventListener('resize', handleResize)

    // Call handler right away so state gets updated with initial window size
    handleResize()

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, []) // Empty array ensures that effect is only run on mount

  return {
    smallScreen: windowSize.width && windowSize.width < theme.responsive.large,
    desktop:
      windowSize.width && windowSize.width > theme.responsive.mediumLarge,
    mobile: windowSize.width && windowSize.width < theme.responsive.small,
    tablet:
      windowSize.width &&
      windowSize.width > theme.responsive.small &&
      windowSize.width &&
      windowSize.width < theme.responsive.large,
    largeDesktop: windowSize.width && windowSize.width > theme.responsive.large,
    windowSize,
  }
}
